const errorMessages = {
  incompleteData: 'Complete los datos para continuar',
  incorrectDate: 'Seleccione una fecha futura',
  notPossibleDate: 'Seleccione una fecha correcta',
};

export default errorMessages;
